import { useRef, useState, useEffect, ReactNode } from 'react';

interface LazySectionProps {
    children: ReactNode;
    /** Khoảng cách trước khi vào viewport bắt đầu load (px) */
    rootMargin?: string;
    /** Placeholder height để giữ layout */
    minHeight?: number | string;
    /** className cho wrapper */
    className?: string;
}

export default function LazySection({
    children,
    rootMargin = '200px',
    minHeight = 200,
    className,
}: LazySectionProps) {
    const ref = useRef<HTMLDivElement>(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { rootMargin },
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, [rootMargin]);

    return (
        <div ref={ref} className={className} style={!isVisible ? { minHeight } : undefined}>
            {isVisible ? children : null}
        </div>
    );
}
